
import { setStorage } from '@/utils/storage'
import { STORAGE_MAKEORDER_LOGIN_TYPE } from '@/utils/train-storage'

export default {
	setMakeOrderLoginType(state, payload) {
		state.is_exemption = payload || 0
		setStorage({ key: STORAGE_MAKEORDER_LOGIN_TYPE, data: payload })
	},
	setMakeOrderBaseInfo(state, payload) {
		state.makeOrderBaseInfo = payload
	},
	openNormalRetentionDrawer(state) {
		state.showNormalRetentionDrawer = true
	},
	closeNormalRetentionDrawer(state) {
		state.showNormalRetentionDrawer = false
	},
	openScrambleRetentionDrawer(state) {
		state.showScrambleRetentionDrawer = true
	},
	closeScrambleRetentionDrawer(state) {
		state.showScrambleRetentionDrawer = false
	},
	setScrambleBtnTrackType(state, payload) {
		state.scrambleBtnTrackType = payload
	},
	setRightCardType(state, payload) {
		state.rightCardType = payload
	},
	setAddedServiceSource(state, payload) {
		const useData = payload?.filter(item => !!item) || []
		state.addedServiceSource = useData
	}
}
